<header class="dlg-h">
    <div class="dlg-meta">
        <h2>Controle leiteiro</h2>
        <p>
            <span class="when">{{ data.summary.formattedStartDate }} {{ data.summary.formattedStartTime }}</span>
            <span class="pill" [class.on]="data.summary.isOpenStatus" [class.off]="!data.summary.isOpenStatus">
                {{ data.summary.controlStatus }}
            </span>
            @if (headerAnimalCount != null) {
            <span class="chip">{{ headerAnimalCount }} animais</span>
            }
            @if (control?.controller?.name) {
            <span class="muted">{{ control.controller.name }}</span>
            }
        </p>
    </div>
    <button
        type="button"
        class="pdf"
        (click)="onPdf()"
        [disabled]="isLoading || hasError || generatingPdf || !animalCount"
        title="PDF do controle"
    >
        @if (generatingPdf) {
        <mat-spinner diameter="16"></mat-spinner>
        } @else {
        PDF
        }
    </button>
    <button type="button" mat-icon-button (click)="onClose()" aria-label="Fechar">
        <mat-icon>close</mat-icon>
    </button>
</header>

<nav class="dlg-tabs" role="tablist" aria-label="Seções do controle">
    <button
        type="button"
        role="tab"
        class="dlg-tab"
        [class.active]="activeTab === 'control'"
        [attr.aria-selected]="activeTab === 'control'"
        (click)="selectTab('control')"
    >
        1. Controle e Produções
    </button>
    <button
        type="button"
        role="tab"
        class="dlg-tab"
        [class.active]="activeTab === 'events'"
        [attr.aria-selected]="activeTab === 'events'"
        (click)="selectTab('events')"
    >
        2. Eventos e Ocorrências
        @if (eventsLoaded && !eventsError && events.length) {
        <span class="tab-count">{{ events.length }}</span>
        }
    </button>
    <button
        type="button"
        role="tab"
        class="dlg-tab"
        [class.active]="activeTab === 'pdfs'"
        [attr.aria-selected]="activeTab === 'pdfs'"
        (click)="selectTab('pdfs')"
    >
        3. Documentos e PDFs
    </button>
</nav>

@if (activeTab === 'control') {
@if (isLoading) {
<div class="state">
    <mat-spinner diameter="32"></mat-spinner>
    <span>Carregando animais…</span>
</div>
} @else if (hasError) {
<div class="state error">
    <mat-icon>error_outline</mat-icon>
    <span>Não foi possível carregar os animais deste controle.</span>
</div>
} @else {
@if (!lots.length) {
<div class="state compact"><span>Nenhum animal lançado neste controle.</span></div>
} @else {
<section class="avg-card" aria-label="Médias do controle">
    <div class="stat geral">
        <span class="label">Média geral</span>
        <strong>{{ formatLiters(controlSummary.overallAverage) }}</strong>
    </div>
    @for (order of orders; track order; let i = $index) {
    <div class="stat">
        <span class="label">{{ order }}ª ordenha</span>
        <strong>{{ formatLiters(controlSummary.averages[i]) }}</strong>
    </div>
    }
</section>
<div class="tools">
    <input type="search" placeholder="Buscar apelido" (input)="onSearch($event)" aria-label="Buscar apelido" />
</div>
<div class="dlg-body">
    @if (!filteredLots.length) {
    <div class="state compact">
        <span>Nenhum animal com esse apelido.</span>
    </div>
    }
    @for (lot of filteredLots; track lot.name) {
    <section class="lot-block">
        <div class="lot-head">
            <h3>{{ lot.name ? 'Lote ' + lot.name : 'Animais sem lote' }}</h3>
            <div class="lot-avgs" aria-label="Médias do lote">
                <span class="lot-avg">
                    <small>Média do lote</small>
                    <b>{{ formatLiters(lot.summary.overallAverage) }}</b>
                </span>
                @for (order of orders; track order; let i = $index) {
                <span class="lot-avg">
                    <small>{{ order }}ª</small>
                    <b>{{ formatLiters(lot.summary.averages[i]) }}</b>
                </span>
                }
                <span class="lot-avg">
                    <small>Animais</small>
                    <b>{{ lot.summary.animalCount }}</b>
                </span>
            </div>
        </div>
        <div class="table-scroll">
        <table>
            <thead>
                <tr>
                    <th>Apelido</th>
                    @for (order of orders; track order) {
                    <th>{{ order }}ª</th>
                    }
                    <th>Total</th>
                </tr>
            </thead>
            <tbody>
                @for (animal of lot.animals; track animal.nickname) {
                <tr>
                    <td class="nick">{{ animal.nickname }}</td>
                    @for (order of orders; track order) {
                    <td [class.reason]="animal.reasons[order]">{{ cell(animal, order) }}</td>
                    }
                    <td class="total">{{ total(animal) }}</td>
                </tr>
                }
            </tbody>
            <tfoot>
                <tr>
                    <th scope="row">Volume por ordenha</th>
                    @for (value of lot.summary.volumes; track $index) {
                    <td>{{ formatLiters(value) }}</td>
                    }
                    <td class="total">{{ formatLiters(lot.summary.grandTotal) }}</td>
                </tr>
                <tr>
                    <th scope="row">Média por ordenha</th>
                    @for (value of lot.summary.averages; track $index) {
                    <td>{{ formatLiters(value) }}</td>
                    }
                    <td class="total">{{ formatLiters(lot.summary.overallAverage) }}</td>
                </tr>
                <tr>
                    <th scope="row">Total animais</th>
                    <td class="count" [attr.colspan]="orders.length + 1">{{ lot.summary.animalCount }}</td>
                </tr>
            </tfoot>
        </table>
        </div>
    </section>
    }
</div>
}
}
} @else if (activeTab === 'pdfs') {
<div class="dlg-body pdf-pane">
    @if (isLoading) {
    <div class="state compact">
        <mat-spinner diameter="28"></mat-spinner>
        <span>Carregando controle…</span>
    </div>
    } @else if (hasError || !control) {
    <div class="state compact error">
        <mat-icon>error_outline</mat-icon>
        <span>Controle indisponível para gerar PDF.</span>
    </div>
    } @else {
    <ul class="pdf-list">
        @for (item of pdfItems; track item.kind) {
        <li class="pdf-row">
            <div>
                <b>{{ item.label }}</b>
                <span>{{ item.hint }}</span>
                @if (pdfs[item.kind].status === 'error') {
                <span class="ev-err">{{ pdfs[item.kind].error }}</span>
                }
            </div>
            <button
                type="button"
                class="pdf"
                (click)="downloadPdf(item.kind)"
                [disabled]="pdfs[item.kind].status === 'generating' || !animalCount"
            >
                @if (pdfs[item.kind].status === 'generating') {
                <mat-spinner diameter="16"></mat-spinner>
                } @else {
                Baixar PDF
                }
            </button>
        </li>
        }
    </ul>
    }
</div>
} @else {
<div class="dlg-body events-pane">
    @if (eventsReportedAt) {
    <div class="events-meta">
        Conferido pelo controlador em {{ eventsReportedAt | date: 'dd/MM/yyyy HH:mm' }}
    </div>
    }

    @if (eventsLoading) {
    <div class="state compact">
        <mat-spinner diameter="28"></mat-spinner>
        <span>Carregando eventos…</span>
    </div>
    } @else if (eventsError) {
    <div class="state compact error">
        <mat-icon>error_outline</mat-icon>
        <span>Não foi possível carregar os eventos.</span>
        <button type="button" class="pdf" (click)="retryEvents()">Tentar novamente</button>
    </div>
    } @else if (!events.length && eventsReportedAt) {
    <div class="state compact"><span>Nenhum evento informado neste controle.</span></div>
    } @else if (!events.length) {
    <div class="state compact"><span>Ainda não há eventos sincronizados.</span></div>
    } @else {
    <ul class="ev-list">
        @for (event of events; track event.id) {
        <li class="ev-row" [class.bad]="isEventBad(event)">
            <div class="ev-type">{{ eventTypeLabel(event.type) }}</div>
            <div class="ev-who">
                <b>{{ event.animal?.nickname || event.animal?.name || 'Animal' }}</b>
                <span>{{ event.date | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="ev-status">
                <span class="status-pill" [class.ok]="event.apiSaved" [class.bad]="!event.apiSaved">
                    {{ event.apiSaved ? 'API' : 'API falhou' }}
                </span>
                <span
                    class="status-pill"
                    [class.ok]="event.srgStatus === 'SENT'"
                    [class.warn]="event.srgStatus === 'PENDING' || event.srgStatus === 'NOT_SENT'"
                    [class.bad]="event.srgStatus === 'FAILED'"
                >
                    {{ srgShortLabel(event.srgStatus) }}
                </span>
            </div>
            @if (eventErrorText(event); as err) {
            <p class="ev-err" [title]="err">{{ err }}</p>
            }
        </li>
        }
    </ul>
    }
</div>
}
